/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".results-per-page-container[_ngcontent-%COMP%]{float:left}.results-per-page-container[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:inline-block;margin-left:5px;margin-right:10px;vertical-align:middle;width:auto}.custom-table-footer__pagination__current-page[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .disabled-page-click[_ngcontent-%COMP%]{pointer-events:none}"];
export { styles as styles };
